import { render, staticRenderFns } from "./ShipmentLineItemStatusDetails.vue?vue&type=template&id=496f75a0&scoped=true"
import script from "./ShipmentLineItemStatusDetails.vue?vue&type=script&lang=js"
export * from "./ShipmentLineItemStatusDetails.vue?vue&type=script&lang=js"
import style0 from "./ShipmentLineItemStatusDetails.vue?vue&type=style&index=0&id=496f75a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f75a0",
  null
  
)

export default component.exports